export default __webpack_public_path__ + "static/media/50.71161ee0.png";